import React from 'react'

export default class AddButtonPopover extends React.Component{
  constructor(props){
    super(props);
    this.state={
      searchValue:'',
    };
    this.popover = React.createRef();
  };

  render(){
    return(
      this.props.viewPopover
      ?
      this.renderPopover()
      :
      null
    );
  };

  renderPopover = () => {
    if (this.props.searchInput && typeof this.props.searchFunction == 'function') {
      return (
        <div className={`new-popover show fade ${this.props.generalPosition}`} style={this.props.generalPosition === "bottom" ? { width: `${this.props.offset}px` } : null}>
          <div className="content">
            <input className='form-control' placeholder='search' onChange={(e)=>this.setState({searchValue: e.target.value})} />
            {this.renderData()}
          </div>
        </div>
      )
    } else {
      return(
        <div className={`new-popover show fade ${this.props.generalPosition}`} style={this.props.generalPosition === "bottom" ? { width: `${this.props.offset}px` } : null}>
          <div className="content">
            {this.renderData()}
          </div>
        </div>
      );
    };
  };
 
  renderData() {
    if (this.props.dataOptions) {
      if (this.props.dataOptions.length) {
        if(this.props.sortData == true) {
          var dataOptions = this.sortData(this.props.dataOptions)
        } else if (this.props.searchInput && typeof this.props.searchFunction == 'function') {
          var dataOptions = this.props.searchFunction(this.props.dataOptions, this.state.searchValue)
        } else {
          var dataOptions = this.props.dataOptions
        }
        var items = dataOptions.map((item) => {
          // Booking Button on add form
          if (item.title) {
            if(item.customer_form == true) {
              return <li key={item.id} onClick={() => this.props.onAdd(item)} ><a href="#" >{`${item.title} `}</a></li>
            } else {
              return null
            }
          } 
          if (item.field) {
            
            if (this.props.all_field_groups) {
              this.addGroupNameToItem(item)
            }
            if (item.field_group_name) {
              return <li key={item.id} onClick={() => this.props.onAdd(item)} ><a href="#" >{`${item.field} (${item.field_group_name})`}</a></li>
            } else {
              return <li key={item.id} onClick={() => this.props.onAdd(item)} ><a href="#" >{`${item.field} `}</a></li>
            }
          } else {
            if(item.room_type && item.room_type.status == "disabled") {

              var formatted_full_name = item.name ? item.name.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ') : `${item.first_name} ${item.last_name}`
              item.full_name = <div style={{color: 'grey'}}>{formatted_full_name}<span className={"ss-alert alert"} title={I18n.t('status_is_disabled')}></span></div>

            } else if (this.props.model == 'RentalsUnitedAmenity') {
              return <li key={item.id} onClick={() => {
                this.setState({searchValue: ''})
                this.props.onAdd(item)}} ><a href="#" dangerouslySetInnerHTML={{ __html: `<div>${item.name}</div>` }} /></li>
            } else {

              item.full_name = item.name ? item.name.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ') : `${item.first_name} ${item.last_name}`
            }
            return <li key={item.id} onClick={() => this.props.onAdd(item)} ><a href="#" >{this.props.column ? item[this.props.column] : item.full_name}</a></li>
          }
        });
        return (
          <div className="add-button-results">
            <ul className="data">
              {items}
            </ul>
          </div>
        );
      } else {
        return <div className="text-center"><span className="none">{I18n.t('none')}</span></div>;
      }
    } else {
      return (
        <div className="add-button-results">
          <div className="spinner" />
        </div>
      );
    }
  }
  
  sortData(data_options) {

    var dataOptions = data_options.sort(function(a, b) {
      const fieldA = a.field.toUpperCase(); // ignore upper and lowercase
      const fieldB = b.field.toUpperCase(); // ignore upper and lowercase
      if (fieldA < fieldB) {
        return -1;
      }
      if (fieldA > fieldB) {
        return 1;
      }
    
      // names must be equal
      return 0;
    });
    return dataOptions
  };


};